import { useState } from 'react';
import { getMaskForType } from '../utils/inputHelpers';

export const useInput = ({ type, value, defaultValue, onChange, onEnter, disabled }) => {
  const [internalValue, setInternalValue] = useState(defaultValue !== undefined ? defaultValue : (value || ''));
  const [showPassword, setShowPassword] = useState(false);
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  const inputType = type === 'password' ? (showPassword ? 'text' : 'password') : type;
  const isMaskedType = ['cpf', 'cnpj', 'telefone', 'cep'].includes(type);
  const currentMask = getMaskForType(type, currentValue);

  const handleChange = (e) => {
    if (type === 'cnpj' && e && e.target && typeof e.target.value === 'string') {
      e.target.value = e.target.value.toUpperCase();
    }
    if (!isControlled) {
      setInternalValue(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter(e);
    }
  };

  const toggleShowPassword = () => {
    if (!disabled) {
      setShowPassword((prev) => !prev);
    }
  };

  return {
    currentValue,
    inputType,
    isMaskedType,
    currentMask,
    showPassword,
    handleChange,
    handleKeyDown,
    toggleShowPassword,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Input/hooks/useInput.js